import { createAction } from 'redux-actions';

export const setDocumentViewModal = createAction(
  'modals/SET_DOCUMENT_VIEW_MODAL'
);

export const setImageViewModal = createAction('modals/SET_IMAGE_VIEW_MODAL');

export const setWATemplatesModal = createAction(
  'modals/SET_WA_TEMPLATES_MODAL'
);

export const setImageGalleryModal = createAction(
  'modals/SET_IMAGE_GALLERY_MODAL'
);

export const setShortLinksModal = createAction('modals/SET_SHORT_LINKS_MODAL');
